export enum PickupType {
  'scheduled' = 'Scheduled',
  'dropBox' = 'Dropbox',
  'onCall' = 'On-Call',
}
